export default {
  hzmbChange: {
    title: {
      formInput: '資料錄入',
      upload: '上傳文件',
      check: '檢查確認',
      payment: "繳費",
      formData: "申請資料",
      owner_data: "配額人資料",
      vehicle: "車輛資料",
      vehicle_tips: "(請填寫新用車輛資料，若更換之車輛涉及轉移車輛註冊號碼，請先完成轉移車輛註冊號碼手續。)",
      new_vehicle: "新用車輛資料",
      macau_vehicle: "澳門車輛資料",
      hk_vehicle: "香港車輛資料",
      mainland_vehicle: "內地車輛資料",
      drivers_data: "駕駛員資料",
      drivers_data_tips: "(請填寫最新一組駕駛員名單，包括保留及新增；若涉及取消駕駛員，只需填寫保留名單。)",
      lastest_drivers_data: "最新一組駕駛員資料",
      already_data: "已錄入資料",
      success: "辦理成功",
    },
    label: {
      changeType: "申請類型",
      validate_type: "驗證方式",
      registrationNo: "車輛的註冊編號",
      identityNo: "澳門居民身份證編號",
      spNo: "查詢編號",
      macau_company_type: "配額公司的商業登記類型",
      companyBrNo: "配額公司的商業登記編號",
      mobileAreaCode: "區號",
      macauMobile: "本澳流動電話(用於短訊通知)",
      phone_code: "手機驗證碼",
      renew: "是否續期",
      renewActive: "續期",
      yes: "是",
      no: "否",
      quotaRegistrationNo: "原車輛的註冊編號",
      personal_idType: "配額人的證件類別",
      personIdentityNo: "配額人的澳門居民身份證編號",
      personNameCn: "配額人的中文姓名",
      personNameEn: "配額人的外文姓名",
      personBirthday: "配額人的出生日期",
      personMacauMobile: "配額人的本澳流動電話",
      personMacauAddress: "配額人的澳門聯絡地址",
      personMainlandPhone: "配額人的內地聯絡電話",
      personMainlandEmail: "配額人的內地電郵地址",
      personHkPhone: "配額人的香港聯絡電話",
      personHkAddress: "配額人的香港聯絡地址",
      companyNameCn: "配額公司的商業登記名稱（中文）",
      companyNameEn: "配額公司的商業登記名稱（外文）",
      company_applicantMobile: "配額公司的本澳流動電話",
      company_macauAddress: "配額公司的澳門聯絡地址",
      company_mainlandPhone: "配額公司的內地聯絡電話",
      company_mainlandEmail: "配額公司的內地電郵地址",
      company_hkPhone: "配額公司的香港聯絡電話",
      company_hkAddress: "配額公司的香港聯絡地址",
      hkInsuranceCompany: "發出香港保險單的保險公司名稱",
      hkInsuranceNo: "車輛的香港保險單編號",
      hkInsuranceStartDate: "車輛的香港保險單生效日期",
      hkInsuranceEndDate: "車輛的香港保險單結束日期",
      mainlandRegistrationNo: "車輛於內地登記車牌編號",
      mainlandInsuranceNo: "車輛的內地保險單編號",
      mainlandInsuranceStartDate: "車輛的內地保險單生效日期",
      mainlandInsuranceEndDate: "車輛的內地保險單結束日期",
      hk_drvIdentNo: "香港居民身份證編號",
      drivers_no: "第{0}駕駛員",
      driver_nameCn: "第{0}駕駛員的中文姓名",
      driver_nameEn: "第{0}駕駛員的外文姓名",
      driver_identityNo: "第{0}駕駛員的澳門居民身份證編號",
      driver_birthday: "第{0}駕駛員的出生日期",
      driver_sex: "第{0}駕駛員的性別",
      driver_nationality: "第{0}駕駛員的國籍",
      driver_other_nationality: "第{0}駕駛員的其他國籍",
      driver_macauDrivingLicenseType: "第{0}駕駛員的澳門駕駛文件類別",
      driver_macauDrivingLicenseNo: "第{0}駕駛員的澳門駕駛文件編號",
      driver_macauMobile: "第{0}駕駛員的本澳流動電話",
      driver_macauAddress: "第{0}駕駛員的澳門聯絡地址",
      driver_mainlandPhone: "第{0}駕駛員的內地聯絡電話",
      driver_mainlandEmail: "第{0}駕駛員的內地電郵地址",
      driver_mainlandDrivingLicenseNo: "第{0}駕駛員的內地駕照編號",
      driver_mainlandDrivingPermitNo: "第{0}駕駛員的內地駕駛許可檔案編號",
      drvMobile: "第{0}駕駛員的流動電話",
      drvAddress: "第{0}駕駛員的聯絡地址",
      drvLicNoHk: "第{0}駕駛員的香港駕照編號",
      drvTempLicNoCn: "第{0}駕駛員的臨時駕駛許可編號",
      drvTempLicNoCnStartDate: "第{0}駕駛員的臨時駕駛許可開始日期",
      drvTempLicNoCnEndDate: "第{0}駕駛員的臨時駕駛許可結束日期",
      mobile: "流動電話(用於短訊通知)",
      guide_change_person: "更換車輛或駕駛員服務（個人配額）",
      guide_change_comp: "更換車輛或駕駛員服務（公司配額）",
      guide_gh_change_comp: "港澳跨境客運更改司機",
    },
    action: {
      verify_submit: "提交驗證",
      next_upload: "下一步：上傳文件",
      next_check: "下一步：檢查確認",
      downloadDynamic: "下載表格",
      statement_detail: "聲明的詳細內容",
      add_drivers: "新增駕駛員",
      submit: "確認無誤並提交",
      statement: "行駛港珠澳大橋駕駛員之聲明",
    },
    message: {
      notNull: "不能為空",
      maxLength: '長度在{0}個字符內',
      spNo_plh: "請輸入查詢編號",
      identityNo_plh: "請輸入澳門居民身份證編號",
      identityNoCheck: "請輸入正確的澳門居民身份證編號",
      macau_company_type_plh: "請輸入配額公司的商業登記類型",
      companyNoCheck: "請輸入正確澳門商業登記編號",
      companyBrNo_tooltips: "例：登記編號 SO 1234，只需輸入1234 便可",
      companyBrNo_plh: "請輸入配額公司的商業登記編號",
      macauMobile: "請輸入正確流動電話號碼",
      mobiltTips: "查詢編號將以短訊及電郵發出，請確保相關資訊無誤。",
      macauMobile_plh: "請輸入本澳流動電話",
      phone_code_placeholder: "請輸入手機驗證碼",
      get_phone_code: "獲取驗證碼",
      getCode_first: "請先獲取驗證碼",
      form_error: "欄位填寫有誤，請檢查！",
      changeTypeTips: "請台端確認是否需要同時辦理香港牌證續期 (倘台端的香港牌證有效期在40天內，可一併辦理續期，並將所需文件交予本局及在各方完成手續後，到本局領證。【因行政程序及郵遞需時，相比自行到香港辦理牌證續期時間較長】)",
      changeTypeTips2: "請台端確認是否需要同時辦理香港牌證續期 (倘台端的香港牌證有效期在40天內，可一併辦理續期)",
      company_applicantMobile: "請輸入配額公司的本澳流動電話",
      applicantMobileTips: "請確保所填寫的澳門流動電話號碼準確，以便接收配額申請手續短訊通知",
      personIdentityNo_plh: "請輸入配額人的澳門居民身份證編號",
      personBirthday_plh: "請輸入配額人的出生日期",
      personal_macauMobile_plh: "請輸入配額人的本澳流動電話",
      macauAddress_plh: "請輸入澳門聯絡地址",
      personal_mainlandPhone_plh: "請輸入配額人的內地聯絡電話",
      personal_mainlandEmail_plh: "請輸入配額人的內地電郵地址",
      personal_hkPhone_plh: "請輸入配額人的香港聯絡電話",
      personal_hkAddress_plh: "請輸入配額人的香港聯絡地址",
      company_macauAddress: "請輸入配額公司的澳門聯絡地址",
      company_mainlandPhone: "請輸入配額公司的內地聯絡電話",
      company_mainlandEmail: "請輸入配額公司的內地電郵地址",
      email_confirm: "請再次輸入電郵地址",
      emial_confirm_tip: "請確保兩次輸入的電郵地址一致",
      company_hkPhone: "請輸入配額公司的香港聯絡電話",
      company_hkAddress: "請輸入配額公司的香港聯絡地址",
      mustAdult: "駕駛員必須年滿18歲",
      hkPhoneCheck: "請輸入正確的香港聯絡電話（數值(0-9)、" - "）",
      mainlandPhoneCheck: "請輸入正確的內地聯絡電話",
      emailCheck: "請輸入正確的電郵地址",
      registNoAndIdNo_plh: "請輸入車輛的註冊編號",
      hkInsuranceCompany_plh: "請輸入發出香港保險單的保險公司名稱",
      hkInsuranceNo_plh: "請輸入車輛的香港保險單編號",
      hkInsuranceStartDate_plh: "請輸入車輛的香港保險單生效日期",
      hkInsuranceEndDate_plh: "請輸入車輛的香港保險單結束日期",
      mainlandRegistrationNo_plh: "請輸入車輛於內地登記車牌編號",
      mainlandInsuranceNo_plh: "請輸入車輛的內地保險單編號",
      mainlandInsuranceStartDate_plh: "請輸入車輛的內地保險單生效日期",
      mainlandInsuranceEndDate_plh: "請輸入車輛的內地保險單結束日期",
      dateRequired: "請選擇日期",
      input_drivers: "把配額人資料自動填寫至",
      notUsed: "不使用",
      hk_drvIdentNo: "請輸入香港居民身份證編號",
      driver_nameCn_plh: "請輸入中文姓名",
      driver_nameEn_plh: "請輸入外文姓名",
      driver_identityNo_plh: "請輸入澳門居民身份證編號",
      driver_birthday_plh: "請輸入出生日期",
      driver_sex_plh: "請輸入性別",
      driver_nationality_plh: "請輸入國籍",
      driver_other_nationality_plh: "請輸入其他國籍",
      driver_macauDrivingLicenseType_plh: "請輸入澳門駕駛文件類別",
      driver_macauDrivingLicenseNo_plh: "請輸入澳門駕駛文件編號",
      driver_mainlandPhone_plh: "請輸入內地聯絡電話",
      driver_mainlandEmail_plh: "請輸入內地電郵地址",
      driver_mainlandDrivingLicenseNo_plh: "請輸入內地駕照編號",
      driver_mainlandDrivingPermitNo_plh: "請輸入內地駕駛許可檔案編號",
      macauDrivingLicenseCheck: "駕駛員之澳門駕駛文件類別+澳門駕駛文件編號不可相同",
      drvMobile: "請輸入流動電話",
      drvAddress: "請輸入聯絡地址",
      addressMin: "澳門聯絡地址需大於5個字",
      drvLicNoHk: "請輸入香港駕照編號",
      drvTempLicNoCn: "請輸入臨時駕駛許可編號",
      drvTempLicNoCnStartDate: "請輸入臨時駕駛許可開始日期",
      drvTempLicNoCnEndDate: "請輸入臨時駕駛許可結束日期",
      onlyChinese: "只允許輸入中文",
      change_drivers_tips: "變更選項將清空第{0}駕駛員資料，是否繼續?",
      upload_required: "缺少必須提交文件，請檢查",
      upload_support_tips: "支持{0}格式上傳，文件大小不超過{1}MB.",
      view_sample: "查看樣本",
      already_upload_file: "已上傳文件：",
      reupload: "重新上傳",
      select_file: "選擇文件",
      upload_extensions_tips: "請上傳後綴名為{0}的文件",
      upload_maxSize_tips: "此文件不能超過{0}MB",
      hzmbFirstAgree: "確定同意為處理有關申請，交通事務局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及駕駛員等的個人資料。",
      agree_statement: "所有現有及新指定的駕駛員必須知悉並同意行駛港珠澳大橋駕駛員之聲明及規定",
      terms_agree: "請勾選聲明",
      validate_type_tips: "(如配額車輛已完成轉移車牌號碼或取消車輛註冊登記手續，因車輛註冊資料已變更或註銷，驗證方式請選擇“查詢編號”)",
      submit_application_tips: "如同時申請辦理更換車輛和更換駕駛員服務，申請類型請選擇“更換車輛及駕駛員”",
      mainlandInsuranceEndDateCheck: '車輛的內地保險單結束日期必須大於等於今天',
    },
    enum: {
      areas: {
        macau: "澳門 +853",
        hongkong: "香港 +852",
        mainland: "内地 +86"
      },
      companyType: {
        CO: '自然人商業企業主(CO)',
        EM: '商業企業(EM)',
        SO: '法人商業企業主(SO)',
      },
      changeType: {
        CHANGE_VEHICLE: "更換車輛",
        CHANGE_DRIVER: "更換駕駛員",
        CHANGE_VEHICLE_DRIVER: "更換車輛及駕駛員"
      }
    },
    terms:
      "<p>" +
      "  1. 應遵事項" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>網上填寫的資料一旦提交後，將無法再進行更改。因此，請在填寫資料時務必小心並仔細核對，並確認所提供的資料準確無誤。</li>" +
      "  <li>申請更換駕駛員期間，被更換的駕駛員及新指定的駕駛員均不能駕駛配額車輛經港珠澳大橋行駛往來港澳。</li>" +
      "  <li>申請更換車輛期間，原配額車輛仍可行駛港珠澳大橋往來港澳，在接獲通知前往馬交石服務專區交換新舊「過境車輛封閉道路通行許可證」和「國際通行許可證」後，原配額車輛及新的配額車輛均不能行駛港珠澳大橋，在完成海關電子通關手續後新的配額車輛方可通行。</li>" +
      "  <li>申請更換車輛服務前，如需更換車輛（保留原車牌）或更換車輛註冊號碼（保留原車輛）手續：</li>" +
      "<ul style='list-style-type: none'>" +
      "  <li>1) 申請人需要先前往馬交石服務專區辦理「申請轉移車牌號碼」之手續；</li>" +
      "  <li>2) 攜同「申請轉移車牌號碼」手續之收據，前往馬交石服務專區交還持有之「國際通行許可證」和「封閉道路通行許可證」，以取消登記該車輛為配額車輛；</li>" +
      "  <li>3) 在完成轉移車牌號碼手續並取得新車輛登記摺及所有權登記憑證後，再辦理更換車輛及/或車輛註冊號等服務。</li>" +
      "</ul>" +
      "  <li>不得連續超過180日處於未有向本局指定配額車輛或指定配額車輛被取消註冊的狀態，否則，將取消有關配額。</li>" +
      "  <li>每一配額均可配備不多於三名指定駕駛員，指定駕駛員須持有有效澳門居民身份證及由澳門當局發出的證明其具相關駕駛資格的牌證。公司配額指定駕駛員必須為公司的持有人或其屬下員工，並須提交有關的證明文件（如公司商業登記證明或由公司負責人簽名及公司蓋章的員工在職證明文件等）；個人配額申請人必須為指定駕駛員，但年齡達70歲或以上之申請人可無須作為指定駕駛員。</li>" +
      "  <li>如需更換使用配額的車輛（下稱“配額車輛＂）、車輛註冊號碼或駕駛員，每項資料的更改將收取費用（澳門元壹仟元正），不論在任何情況下，所有已支付的費用將不予退還。</li>" +
      "  <li>配額持有人須於辦理服務後180日內交妥所需文件，否則服務將自動取消，不論在任何情況下，所有已支付的費用將不予退還。</li>" +
      "  <li>配額車輛須為配額持有人在澳門註冊登記為私人用途的輕型客車，而為符合香港的法例要求，由首次登記日期起計車齡達六年或以上的車輛必須在每年辦理「過境車輛封閉道路通行許可證」及「國際通行許可證」前於澳門通過檢驗；配額持有人亦必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
      "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
      "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，可行駛港珠澳大橋往來港澳兩地，任何人須自行對因其自身、內地或香港的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
      "  <li>申請人及配額持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其配額可被取消，而自查實確認之日起計三年內，其申請將不予受理，以及可被追究相應的刑事責任。</li>" +
      "  <li>如發現配額車輛曾超出通行區、通行條件或並非由指定駕駛員駕駛，自查實確認之日起計一年，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
      "  <li>經澳門海關張貼在配額車輛的「車輛通關電子標籤」(RFID)，在配額有效期間不得任意移除，違反者將可被視作超出通行條件處理。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  2. 個人資料的保護" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  3. 免責聲明" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  4. 私隱條款" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
      "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  5. 使用條款的改變" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
      "</ul>",
    terms_bus:
      "<p>" +
      "  1. 應遵事項" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>申請更改駕駛員須符合對應巴士或出租車服務規定之要求（按此進入「珠海交警互聯服務平臺」了解http://bridge.zhjj.org.cn:9080/），否則有關申請將不予批准。</li>" +
      "  <li>港澳跨境巴士及港澳跨境出租車，每一車輛均可配備不多於三名指定駕駛員。</li>" +
      "  <li>申請更換駕駛員期間，被更換的駕駛員及新指定的駕駛員均不能駕駛配額車輛經港珠澳大橋行駛往來港澳。</li>" +
      "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例。</li>" +
      "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，方可行駛港珠澳大橋往來港澳兩地，任何人或公司須自行對因其自身、內地、香港或澳門的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
      "  <li>配額持有人、指定駕駛員或配額車輛如違反申領配額及港澳有關牌證的條款，其有關配額及牌證可被取消。</li>" +
      "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其更改司機申請亦將不予受理。</li>" +
      "  <li>經澳門海關張貼在配額車輛的「車輛通關電子標籤」(RFID)，在配額有效期間不得任意移除，違反者將可被權限部門作出相應處理。</li>" +
      "  <li>交通事務局會將本申請結果連同所有新任司機的身份證明文件資料通知澳門海關。</li>" +
      "  <li>申請人及配額持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則可被追究相應的責任。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  2. 個人資料的保護" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，為使申請人於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)，並得到妥善保存。上述個人資料將保存至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
      "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
      "  <li>申請人提供的所有個人資料，將按照澳門特別行政區第 8/2005 號法律《個人資料保護法》的規定進行處理，本局於審查文件時遇有疑問，有關資料可能會送交予有權限機構作驗證或查詢。申請人依法享有資訊權、查閱權、更正權及反對權，在行使有關權利時，必須以書面方式向本局提出。申請人向本局提交任何個人資料前，必須已獲得資料當事人之同意及向其提供第 8/2005 號法律《個人資料保護法》第 10 條第 1 款規定的資訊。 </li>" +
      "  <li>為處理有關申請，本局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第 8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及司機等的個人資料。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  3. 免責聲明" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。本局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。本局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  4. 使用條款的改變" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>若本使用條款有任何更新，本局將以新版本取代舊版本發佈，並在文件中列明更新的修訂日期，但不作另行公佈。</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  5. 聯絡方法" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
      "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
      "  <li>交通事務專線：(853) 8866 6363</li>" +
      "  <li>電郵：info@dsat.gov.mo</li>" +
      "</ul>",
  }
}